import classNames from 'classnames';

type Props = {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
};
export function CarouselPage({ className, ...props }: Props) {
    return (
        <div
            {...props}
            className={classNames(
                className,
                'inline-block w-full shrink-0 grow-0 snap-center snap-always whitespace-normal align-top',
            )}
        />
    );
}
